// Pop-ups the CRM 2.0 card can open (M3). Each M3 function adds its own entry:
//   key (the action name the stage uses): { type, Component, available(card) }
// The card turns every available entry into actions[key](mode) and mounts the Component with
// { allotment, card, mode, onClose, onDone, reload }.
import AfbConfirmModal from "./AfbConfirmModal";
import Crm2KycModal from "./Crm2KycModal";
import ReviewDraftModal from "./ReviewDraftModal";
import CancelUnitModal from "./CancelUnitModal";
import Crm2DiscountModal from "./Crm2DiscountModal";

const stage1 = (card) => card?.stage === 1 && card?.bookingState !== "WAITING_RM";
const afbConfirmed = (card) => !!card?.afb?.confirmedAt || (card?.steps?.[1] || []).some((s) => s.stepCode === "AFB_CONFIRMED" && s.status === "DONE");

export const crm2CardModals = {
	// M3-F6 · Application for Booking · View & Confirm
	openAfb: { type: "afb", Component: AfbConfirmModal, available: (card) => stage1(card) },
	// M3-F3 / F5 / F7 · Agreement KYC (new · edit · correct); opens only after the AfB confirmation (DC-167)
	openKyc: { type: "kyc", Component: Crm2KycModal, available: (card) => stage1(card) && afbConfirmed(card) && card?.kyc?.editable !== false },
	// M3-F4 · review draft · every applicant confirms by OTP
	openReview: { type: "review", Component: ReviewDraftModal, available: (card) => stage1(card) && !!card?.reviewDraft?.documentId },
	// M4-F6 · discount pop-ups (mode = start step: gift · disc · final:loy · final:keep · pick:addback · pick:toref)
	openDiscount: { type: "discount", Component: Crm2DiscountModal, available: (card) => stage1(card) && !!card?.discounts },
	// M3-F10 · Cancel Unit: hidden while Shortlisted and while waiting for a CRM (DC-120); until handover
	openCancel: { type: "cancel", Component: CancelUnitModal, available: (card) => typeof card?.stage === "number" && card.stage >= 1 && card.stage < 5 && card.bookingState !== "WAITING_RM" },
};
